// extracted by mini-css-extract-plugin
module.exports = {"input":"HomeSearchInput_input__JKyp5","inputSplitter":"HomeSearchInput_inputSplitter__kOwL9"};